export default __webpack_public_path__ + "static/media/pptSlideLast.16e0e425.png";